export enum Direction {
  TO = 0,
  BACK = 1
}
